import { Plus as PlusIcon } from "@tamagui/lucide-icons";
import { Button, Title5, XStack, YStack } from "@medbillai/ui";
import { CASES_PANEL_NEW_CASE_BUTTON_SOURCE, usePushGetHelp } from "../../../lib/usePushGetHelp";
import { CaseListFilterPopover } from "./CaseListFilterPopover";
import { CaseListInner } from "./CaseListInner";
import type { ListProps } from "./List";
export type CaseListProps = ListProps;
export const CaseList = ({
  issues,
  loading,
  fetchMore,
  showRead,
  showUnread,
  showClosed,
  onFilterChange,
  currentIssueId,
  endReached,
  source
}: CaseListProps) => {
  const {
    pushGetHelp
  } = usePushGetHelp();
  const handleNewCasePress = () => {
    pushGetHelp({
      caseType: "OTHER",
      title: "Get started with Granted",
      source: CASES_PANEL_NEW_CASE_BUTTON_SOURCE
    });
  };
  return <YStack f={1} width="100%" data-sentry-element="YStack" data-sentry-component="CaseList" data-sentry-source-file="CaseList.tsx">
      <XStack width="100%" backgroundColor="$surface1" paddingHorizontal="$sp2" borderBottomWidth={1} borderBottomColor="$uiStroke" $sm={{
      borderTopWidth: 1,
      borderTopColor: "$uiStroke"
    }} justifyContent="space-between" alignItems="center" height="$4.5" data-sentry-element="XStack" data-sentry-source-file="CaseList.tsx">
        <Title5 data-sentry-element="Title5" data-sentry-source-file="CaseList.tsx">Cases</Title5>

        <XStack gap="$2.5" data-sentry-element="XStack" data-sentry-source-file="CaseList.tsx">
          <CaseListFilterPopover showRead={showRead} showUnread={showUnread} showClosed={showClosed} onFilterChange={onFilterChange} data-sentry-element="CaseListFilterPopover" data-sentry-source-file="CaseList.tsx" />

          <Button onPress={handleNewCasePress} size="small" fillWidth={false} variant="tertiary" icon={PlusIcon} data-sentry-element="Button" data-sentry-source-file="CaseList.tsx" />
        </XStack>
      </XStack>

      <CaseListInner issues={issues} fetchMore={fetchMore} loading={loading} showRead={showRead} showUnread={showUnread} showClosed={showClosed} endReached={endReached} currentIssueId={currentIssueId} source={source} listProps={{
      style: {
        flex: 1
      }
    }} data-sentry-element="CaseListInner" data-sentry-source-file="CaseList.tsx" />
    </YStack>;
};